const velicinaUloskaData = [
  { range: "24-25", min: 156, max: 168.9, avg: 162.45, initialHeight: 12, finalHeight: 15 },
  { range: "26-27", min: 169, max: 181.9, avg: 175.45, initialHeight: 12, finalHeight: 16 },
  { range: "28-29", min: 182, max: 194.9, avg: 188.45, initialHeight: 12, finalHeight: 17 },
  { range: "30-31", min: 195, max: 207.9, avg: 201.45, initialHeight: 13, finalHeight: 17 },
  { range: "32-33", min: 208, max: 220.9, avg: 214.45, initialHeight: 13, finalHeight: 17 },
  { range: "34-35", min: 221, max: 233.9, avg: 227.45, initialHeight: 14, finalHeight: 18 },
  { range: "35-36", min: 227.5, max: 240.4, avg: 233.95, initialHeight: 14, finalHeight: 18 },
  { range: "36-37", min: 234, max: 246.9, avg: 240.45, initialHeight: 15, finalHeight: 19 },
  { range: "38-39", min: 247, max: 259.9, avg: 253.45, initialHeight: 15, finalHeight: 19 },
  { range: "40-41", min: 260, max: 272.9, avg: 266.45, initialHeight: 15, finalHeight: 20 },
  { range: "42-43", min: 273, max: 285.9, avg: 279.45, initialHeight: 15, finalHeight: 20 },
  { range: "44-45", min: 286, max: 298.9, avg: 292.45, initialHeight: 15, finalHeight: 20 },
  { range: "46-48", min: 299, max: 311.9, avg: 305.45, initialHeight: 15, finalHeight: 20 },
];

// const findClosestObject = (number) => {
//   // Assuming velicinaUloskaData is the array of objects
//   const sortedData = [...velicinaUloskaData].sort((a, b) => {
//     const aRange = a.range.split("-").map(Number);
//     const bRange = b.range.split("-").map(Number);

//     const aMidpoint = (aRange[0] + aRange[1]) / 2;
//     const bMidpoint = (bRange[0] + bRange[1]) / 2;

//     return Math.abs(number - aMidpoint) - Math.abs(number - bMidpoint);
//   });

//   return sortedData[0];
// };

const findClosestObject = (number) => {
  let closest = velicinaUloskaData[0];
  let closestDistance = Math.abs(number - (parseInt(closest.range.split("-")[0]) + parseInt(closest.range.split("-")[1])) / 2);

  for (let i = 1; i < velicinaUloskaData.length; i++) {
    const range = velicinaUloskaData[i];
    const midpoint = (parseInt(range.range.split("-")[0]) + parseInt(range.range.split("-")[1])) / 2;
    const distance = Math.abs(number - midpoint);

    if (distance < closestDistance) {
      closest = range;
      closestDistance = distance;
    }
  }

  return closest;
};


// function findRange(leftFootLength, rightFootLength) {
//   const minLength = Math.min(leftFootLength, rightFootLength);
//   const maxLength = Math.max(leftFootLength, rightFootLength);

//   // Check if the range is lower than the first or higher than the last
//   if (minLength < velicinaUloskaData[0].min) {
//     //console.log(velicinaUloskaData[0], 'find range data');
//     return velicinaUloskaData[0];
//   } else if (maxLength > velicinaUloskaData[velicinaUloskaData.length - 1].max) {
//     //console.log(velicinaUloskaData[velicinaUloskaData.length - 1], 'find range data');
//     return velicinaUloskaData[velicinaUloskaData.length - 1];
//   }

//   // Check for ranges between the data
//   for (let i = 0; i < velicinaUloskaData.length; i++) {
//     const data = velicinaUloskaData[i];

//     if (minLength >= data.min && maxLength <= data.max) {
//       //console.log(data, 'find range data');
//       return data;
//     }

//     // Check if max is in the next range
//     if (i < velicinaUloskaData.length - 1 && maxLength > data.max && maxLength <= velicinaUloskaData[i + 1].max) {
//       //console.log(velicinaUloskaData[i + 1], 'find range data (next range)');
//       return velicinaUloskaData[i + 1];
//     }
//   }

//   return null; // or any other value to indicate no matching range found
// }

function findRange(leftFootLength, rightFootLength) {
  const minLength = Math.min(leftFootLength, rightFootLength);
  const maxLength = Math.max(leftFootLength, rightFootLength);

  // If below the smallest range
  if (minLength < velicinaUloskaData[0].min) {
    return velicinaUloskaData[0];
  }

  // If above the largest range
  if (maxLength > velicinaUloskaData[velicinaUloskaData.length - 1].max) {
    return velicinaUloskaData[velicinaUloskaData.length - 1];
  }

  // Check for ranges between the data
  for (let i = 0; i < velicinaUloskaData.length; i++) {
    const data = velicinaUloskaData[i];

    if (minLength >= data.min && maxLength <= data.max) {
      return data; // Found the range directly
    }

    // Check if max is within the next range
    if (i < velicinaUloskaData.length - 1 && maxLength > data.max && maxLength <= velicinaUloskaData[i + 1].max) {
      return velicinaUloskaData[i + 1]; // Found the next range
    }
  }

  return null; // Return null if no range found
}

export { velicinaUloskaData, findClosestObject, findRange };
